export const UsefullDocsIcon = ({ className }) => {
  return (
    <svg
      width={80}
      height={80}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_9743_4217)">
        <path
          d="M25.8657 39.9971H54.1499"
          stroke="#A5A5A5"
          strokeWidth={5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.9384 24.9952L61.2099 25.0085C65.1668 25.0407 68.9508 26.6352 71.7374 29.4446C74.5241 32.2541 76.0877 36.0509 76.0877 40.008C76.0877 43.9651 74.5241 47.7618 71.7374 50.5713C68.9508 53.3807 65.1668 54.9752 61.2099 55.0075L47.9362 54.9964"
          stroke="#A5A5A5"
          strokeWidth={5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.0768 24.9947L18.8052 25.008C14.8483 25.0402 11.0644 26.6347 8.2777 29.4442C5.49103 32.2536 3.9274 36.0504 3.9274 40.0075C3.9274 43.9646 5.49103 47.7614 8.2777 50.5708C11.0644 53.3803 14.8483 54.9748 18.8052 55.007L32.079 54.9959"
          stroke="#A5A5A5"
          strokeWidth={5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9743_4217">
          <rect width={80} height={80} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
